import { render, staticRenderFns } from "./CardSummary.vue?vue&type=template&id=6dae6679&scoped=true"
import script from "./CardSummary.vue?vue&type=script&lang=ts"
export * from "./CardSummary.vue?vue&type=script&lang=ts"
import style0 from "./CardSummary.vue?vue&type=style&index=0&id=6dae6679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dae6679",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSortTheSort: require('/usr/src/nuxt-app/components/core/sort/TheSort.vue').default})
